module.exports = {"baseUrl":"https://shop.highdemandbrands.eu/api/","tokenUrl":"https://shop.highdemandbrands.eu/token","mapsKey":"AIzaSyAiZg3CaWE6xvJhGvw_MxADoQgux9Y18wM"}


//////////////////
// WEBPACK FOOTER
// ./src/config/index.json
// module id = CwQk
// module chunks = 1